import React from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const MAP = {
  "Not Started": "bg-slate-200 text-slate-700",
  "Pending Shipment": "bg-slate-200 text-slate-700",
  "Pending": "bg-amber-500 text-white",
  "Active": "bg-blue-600 text-white",
  "In Progress": "bg-blue-500 text-white",
  "Under Review": "bg-amber-500 text-white",
  "Pending Closure": "bg-indigo-500 text-white",
  "Pending Reconciliation": "bg-orange-600 text-white",
  "Complete": "bg-emerald-500 text-white",
  "Completed": "bg-emerald-500 text-white",
  "Others": "bg-slate-400 text-white",
  "Pending Installation": "bg-slate-200 text-slate-700",
  "Approved": "bg-emerald-500 text-white",
  "Declined": "bg-red-500 text-white",
};

export function StatusBadge({ status, testid }) {
  const { t } = useTranslation();
  return (
    <Badge
      data-testid={testid || `status-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={cn("overline rounded-md border-0 px-2.5 py-1", MAP[status] || "bg-slate-200 text-slate-700")}
    >
      {status ? t(`status.${status}`, status) : status}
    </Badge>
  );
}
